import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../core/services/theme.service';
import { LottieComponent } from 'ngx-lottie';
 

import { BaseComponent } from '../../../core/components/base.component';
import player from 'lottie-web';

export function playerFactory() {
    return player;
}
@Component({
  selector: 'berry-loader',
    standalone: true,
    imports: [CommonModule, LottieComponent],
    providers: [
       
    ],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent extends BaseComponent implements OnInit {
    protected override ngSuperOnInit() {
        if (this.themeService.showThemeDialog)
            this.options = this.themeService.getLoader(this.themeService.themeData.LoaderLogoPath);
        else {
            //this._appData.LoadConfigurations().subscribe((resp: any) => {
            //    if (resp)
            this.options = this.themeService.getLoader(this._appData.configurations.loaderLogoPath);
           // });
           
        }
    }
    protected override ngSuperAfterViewInit() {
       
    }
    protected override ngSuperOnDestroy() {
        
    }

    @Input("size") size = 40;


    options!: any;

    constructor(private themeService: ThemeService) {
        super()
    }

  
}
